import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { reducer } from './reducer';
import { ProjectsStoreEffects } from './effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('projects', reducer),
    EffectsModule.forFeature([ProjectsStoreEffects]),
  ],
  providers: [],
})
export class ProjectsStoreModule {}
